import styled from 'styled-components';

import moTheme from '@ecp/common/src/style/theme/mo';
import { TextBox } from '@ecp/common/src/text/TextBox';

const Container = styled.div`
  padding: 14px 20px;
  width: 100%;
`;

const InfoTextBox = styled(TextBox)`
  font-size: ${({ size }) => size || moTheme.font.size.$12};
  line-height: ${moTheme.font.lineHeight.demiLight};
  font-weight: ${({ weight }) => weight || moTheme.font.weight.demiLight};
`;

export { Container, InfoTextBox };
